import SectionLabel from './SectionLabel';
import studioMixer from '../../assets/images/about/about-studio-mixer.jpg';

const stats = [
  { value: '1350+', label: 'ARTISTS' },
  { value: '100+', label: 'PROJECTS' },
  { value: '10+', label: 'MAJOR LABELS' },
];

const highlights = [
  { title: 'INDUSTRY GIANTS', body: 'T-Series, Saregama, Universal Music Group' },
  { title: 'CELEBRATED ARTISTS', body: 'Vilen, Taba Chake, Param, Talwinder' },
  { title: 'COMMUNITY', body: 'A thriving community of creators' },
];

const ImpactSection = () => {
  return (
    <section className="bg-black pt-[64px] md:pt-[100px] lg:pt-[142px] pb-[64px] md:pb-[100px] lg:pb-[130px]">
      {/* Heading block */}
      <div className="max-w-[1108px] mx-auto px-5 md:px-8 lg:px-0">
        <SectionLabel>OUR IMPACT</SectionLabel>
        <h2 className="mt-[16px] md:mt-[22px] text-center text-white font-bold leading-[1.12] text-[28px] sm:text-[34px] md:text-[40px] lg:text-[54px]">
          Journey &amp; Results
        </h2>
        <p className="mt-[20px] md:mt-[28px] mx-auto max-w-[800px] text-center text-white/60 text-[14px] md:text-[16px] lg:text-[18px] leading-[1.6]">
          Our growth is a testament to the quality of our work. We have moved from a startup to a key
          player in the Indian music scene, delivering results for the biggest names in the business.
        </p>
      </div>

      {/* Stats + hero image sit in a wider container, as in the design */}
      <div className="mt-[32px] md:mt-[56px] lg:mt-[80px] max-w-[1376px] mx-auto px-5 md:px-8 lg:px-0">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-[16px] md:gap-[24px] lg:gap-[32px]">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-[12px] border border-white/10 bg-[#131313] py-[26px] md:py-[46px] lg:py-[56px] px-[20px] text-center"
            >
              <div className="text-white font-bold leading-none text-[40px] md:text-[48px] lg:text-[62px]">
                {stat.value}
              </div>
              <div className="mt-[14px] md:mt-[20px] text-white/50 text-[10px] md:text-[11px] lg:text-[12px] uppercase tracking-[0.18em]">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-[24px] md:mt-[48px] lg:mt-[75px]">
          <img
            src={studioMixer}
            alt="Close-up of a studio mixing console"
            className="w-full h-[200px] sm:h-[300px] md:h-[400px] lg:h-[497px] object-cover"
          />
        </div>
      </div>

      {/* Copy + highlight cards */}
      <div className="mt-[28px] md:mt-[48px] lg:mt-[70px] max-w-[1108px] mx-auto px-5 md:px-8 lg:px-0">
        <p className="text-white/70 text-[15px] md:text-[16px] lg:text-[18px] leading-[1.62]">
          We have successfully executed marketing and production projects for industry giants like
          T-Series, Saregama, and Universal Music Group Etc. We have contributed to the journeys of
          celebrated artists like Vilen, Taba Chake, Param, and Talwinder, and provided scoring and
          mixing for major commercial ad films.
        </p>
        <p className="mt-[18px] md:mt-[26px] text-white/70 text-[15px] md:text-[16px] lg:text-[18px] leading-[1.62]">
          Simultaneously, we have built a community of 1350+ artists, proving that we can operate at
          the highest level of the industry while staying true to the creators who fuel it.
        </p>

        <div className="mt-[28px] md:mt-[48px] lg:mt-[64px] grid grid-cols-1 md:grid-cols-3 gap-[12px] md:gap-[24px]">
          {highlights.map((item) => (
            <div
              key={item.title}
              className="rounded-[8px] border border-white/10 bg-[#131313] px-[20px] py-[18px] md:py-[22px]"
            >
              <h3 className="text-white font-bold uppercase text-[14px] md:text-[15px] lg:text-[16px] tracking-[0.04em]">
                {item.title}
              </h3>
              <p className="mt-[8px] md:mt-[12px] text-white/50 text-[12px] md:text-[13px] lg:text-[14px] leading-[1.45]">
                {item.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImpactSection;
